import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ServiceManagePageRoutingModule } from './service-manage-routing.module';

import { ServiceManagePage } from './service-manage.page';
import {DirectivesModule} from '../directives/directives.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ServiceManagePageRoutingModule,
        DirectivesModule
    ],
  declarations: [ServiceManagePage]
})
export class ServiceManagePageModule {}
